import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { TipOtpremnice } from './tip-otpremnice';

@Component({
  selector: 'yt-tip-otpremnice',
  templateUrl: './tip-otpremnice.component.html'
})
export class TipOtpremniceComponent extends BaseModalContainer<TipOtpremnice> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipOtpremnice>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
